import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import SsoFeaturebaseRedirect from '../components/external_sso/SsoFeaturebaseRedirect'
import LoadingSpinner from '../components/general/LoadingSpinner'
import SSoSignInPage from '../components/sessions/SSoSignInPage'
import ProtectedApp from './ProtectedApp'
import SessionsRoutes from './SessionsRoutes'

export default function MFRouter() {
  /** @type {import('../reducers/adminsReducer.js').CurrentAdmin} */
  const currentAdmin = useSelector(state => state.admins.current_admin)
  /** @type {import('../reducers/loadingReducer').LoadingState} */
  const loading = useSelector(state => state.loading)
  /** @type {import('../redux/storeConfig/slices/slice.auth/auth.types').AuthSlice}*/
  const auth = useSelector(state => state.auth)

  const isLoggedIn = useMemo(() => !!(auth.token && currentAdmin?.id), [auth.token, currentAdmin?.id])

  const loggedInAsContext = useMemo(() => {
    switch (currentAdmin?.logged_in_as) {
      case 'Agency':
        return 'Agency'
      case 'Organization':
        return 'Organization'
      default:
        return null
    }
  }, [currentAdmin?.logged_in_as])

  if (auth.currentAdminId === 'init' || auth.tokenVerified === 'init') return <LoadingSpinner />

  return (
    <Switch>
      <Route path="/sso-log-in/:sso_id/:sso_token" component={SSoSignInPage} />
      <Route path="/sso/external/featurebase" component={SsoFeaturebaseRedirect} />

      <Route exact path={['/login', '/forgot_password', '/reset_password/:token', '/auth0_callback']}>
        <SessionsRoutes isLoggedIn={isLoggedIn} />
      </Route>

      <Route path="/">
        <ProtectedApp isLoggedIn={isLoggedIn} loggedInAsContext={loggedInAsContext} />
      </Route>
    </Switch>
  )
}
